export default "__VITE_ASSET__8672a521__"